import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useSizesSection} from '../useGetProductBulkSection';
import {
  SoldOutSizeReminderFlyoutView,
  SoldOutSizeReminderFlyoutViewProps,
} from './SoldOutSizeReminderFlyoutView';

export const SoldOutSizeReminderFlyout = (
  props: SoldOutSizeReminderFlyoutViewProps,
) => {
  return (
    <DataFetcher
      request={useSizesSection()}
      Error={null}
      View={SoldOutSizeReminderFlyoutView}
      viewProps={props}
    />
  );
};
